module.exports = __webpack_public_path__ + "static/media/Shopping.24964034.png";